import React from 'react';
import {curry} from 'ramda';
import {Link} from 'react-router-dom';
import {MediaOrdersFilterHandlers} from './MediaOrdersListTypes';
import {handleFilters} from '@pluto/handlers';

export const getMediaOrdersFilters = (filterHandlers: MediaOrdersFilterHandlers) => {
    const handleContentPartnersChange = handleFilters({
        ...filterHandlers,
        key: 'contentPartnerId',
    });

    const handleLabPartnersChange = handleFilters({
        ...filterHandlers,
        key: 'labPartner',
    });

    return {
        handleContentPartnersChange,
        handleLabPartnersChange,
    };
};

export const renderMediaOrderLink = curry((route, {mediaOrderId}) => {
    return <Link to={`${route}/${mediaOrderId}`}>{mediaOrderId}</Link>;
});
